import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue'
// import { t } from 'i18next/dist/commonjs';
import pageRoute from '@/libs/constant/pageRoutes'
import {getIamUsersForUser, leaveOrganisation} from '@/libs/api/api'
// import {Event} from 'vue-tables-2'
import TableFilters from '@/components/component/Reuse/TableFilters/TableFilters.vue'
import BulkUpdate from './BulkUpload/BulkUpdate.vue'
import ChangeRole from '../ChangeRole/ChangeRole.vue'
import constants from '@/libs/constant/constants';
import {cloneDeep, isEmpty} from 'lodash'
import {message, errorHandler, logout, getImageUrl, loader, routeErrorHandler} from '@/libs/helper'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
export default {
    name: 'Iamuser',
    mixins: [OrganisationRolesErrorHandlerMixin],
    data() {
        return {
            isEmpty,
            isInvite: false,
            isUpdatePeople: false,
            invitationToBeUpdated: {},
            peopleCounts: {},
            pageSize: '10',
            selectedTableFilters: {},
            category: '',
            tableFilters: {},
            usersTableData: [],
            getImageUrl,
            tableDataCount:null,
            columns: ['name', 'role', 'teams', 'user_groups', 'permissions', 'settings'],
            tableSettings: {
                headings: {
                    name: 'Name',
                    seats: '',
                    role: 'Role',
                    teams: 'Teams',
                    user_groups: 'User groups',
                    permissions: 'Permissions',
                    //   settings:''
                },
                pagination: { show: true},
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                perPageValues:[]
            },
            settingOptions: [
                { command: 'CHANGE_ROLE', label: 'Change Role' },
                // { command: 'CONVERT_TO_COLLABORATOR', label: 'Convert to Collaborator' },
                { command: 'REMOVE_FROM_ORGANISATION', label: 'Remove from Organisation', isDelete: true }
            ],
            sortingKey: 'name',
            sortingOrder: 'desc',
            limit: 25,
            currentPage: 1,
            skip: 0,
            previousPage : 1,
            sort: 'screen_name',
            order: 'asc',
            selected:4,
            selectedEntries:[],
            searchValue:'',
            loadingTableData:false,
            selectedValue: 10,
            totalTableData: 0,
            isBulkEdit: false,
            organisation: '',
            isChangeRole: false,
            selectedUser: {}
        }
    },
    components: {
        SettingsDropdown,
        TableFilters,
        BulkUpdate,
        ChangeRole,
        InvitePeople: () => import('@/components/pages/InformationPortal/Organisation/InvitePeople/InvitePeople.vue'),
    },
    computed: {
        perPageSelect: {
            get(){
                return this.pageSize
            },
            set(val){
                this.pageSize = val
                this.skip=0
                this.currentPage = 1
                this.loadTableData()
            }
        }
    },
    watch: {
        totaltableData (value) {
            this.totalPage = value
        },
        selectedValue (value) {
            this.selected = value || this.perPage
        },
        tableData (value) {
            this.rowsData = value
        },
        selectedTableFilters (value) {
            this.tableFilters = value
        }
    },
    created(){
        this.loadTableData();
    },
    methods:{
        closeInviteDialog () {
            console.log(this.$attrs.currentOrganisation)
            this.isInvite = false
            this.isUpdatePeople = false
            this.invitationToBeUpdated = {}
        },
        refreshLogs () {
            // to update counts
            // this.getInviteCounts()
            // if (this.selectedMenu === constants.PEOPLE_LIST.PENDING_INVITATION) this.fetchPeopleList()
        },
        /**
         * to get the counts of invite
         */
        //  getInviteCounts () {
        //     // api call
        //     inviteCount({organisation: this.$route.params.id}).then(response => {
        //         this.peopleCounts = response || {}
        //         let count = Object.values(response).reduce((a, b) => a+b, 0)
        //         this.updateCount(constants.PEOPLE_LIST.PEOPLE, count)
        //     }).catch(error => {
        //         console.error(error)
        //     })
        // },
        handleCommand (option, data) {
            switch (option) {
                case 'DELETE':
                    // remove people
                    this.removePeople(data)
                break
                case 'CONVERT_TO_COLLABORATOR':
                break
                case 'CHANGE_ROLE':
                    this.selectedUser = data
                    this.isChangeRole = true
                break
                case 'UPDATE_INVITATION': 
                    this.invitationToBeUpdated = cloneDeep(data)
                    this.isUpdatePeople = true
                    this.isInvite = true
                break
                case 'CANCEL_INVITATION': 
                    this.removePendingRequest(data)
                break
                case 'CANCEL_INVITATION_COLLABORATOR':
                    this.removePendingRequest(data, true)
                break
            }
        },
        /**
         * remove people from organisation 
         */
         removePeople (people) {
            console.log(people)
            const mainTitle = `${window.i18next.t(`Remove person`)} `;
            const nameTitle = `${people.user.screen_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a person, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the person, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(() => {
                    // api all
                    loader(this, true)
                    // body for api
                    let body = {
                        user_id: people.id
                    }
                    // api call
                    leaveOrganisation(this.$route.params.id || this.$attrs.currentOrganisation._id, body).then(() => {
                        // to get the updated list of people
                        // this.fetchPeopleList()
                        // get the refreshed counts
                        // this.getInviteCounts()
                        this.loadTableData()
                        loader(this, false)
                    }).catch(error => {
                        loader(this, false)
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                        // error handler for permissions
                        this.rolesErrorHandler(error)
                    })
                }).catch((error) => {
                    console.error('--', error)
                })
        },

        gotoCreateUserGroup(){
            this.$router.push({name:pageRoute.iamCreateGroup,params:{id:this.currentOrganisation && this.currentOrganisation._id}})
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            // call api and and set updated data
            this.loadTableData()
        },
        handleCheckBoxSelect(row){
            let id=row.id
            if (!this.selectedEntries.includes(id)) {
                this.selectedEntries.push(id)
            } else {
                const index = this.selectedEntries.indexOf(id)
                if (index > -1) {
                this.selectedEntries.splice(index, 1);
                }
            }
        },
        bulkEdit () {
            this.isBulkEdit = true
        },
        testButton () {
            this.selectedEntries = []
            this.isBulkEdit = false
            this.clearSearchInput()
        },
        closeChangeRolePopup() {
            this.isChangeRole = false
        },
        refreshPage () {
            this.clearSearchInput()
        },
        async querySearch (query, cb) {
            if(query === undefined || query === '' || query.length < 2){
                return
            }
            let searchResult = []
            try{
                let body={searchText:query}
                let params= `?skip=${0}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
                let id = this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
                searchResult = await getIamUsersForUser(id , params ,body)
                this.tableDataCount= searchResult && searchResult.result.total_count;
                this.usersTableData = searchResult.result.items.map((user) => {
                    return {
                        user: user.userDetails[0],
                        role: user.organisation_role,
                        team_count: user.team_count,
                        user_group_count: user.userGroup_count,
                        permissions: user.permissions,
                        id:user.entity_id
                    }
                })
            }catch(error){
                console.log("error",error)
                return error
                
            }
            // call callback function to return suggestion objects
            cb(searchResult.result.items);
    },
        handleSelectValue(val){
            this.searchValue = val.userDetails[0].screen_name
        },
        
        changeSort(sortingKey) {
            this.sortingOrder = this.sortingKey !== sortingKey ? 'desc' : this.sortingOrder === 'desc' ? 'asc' : 'desc'
            this.sortingKey = sortingKey
            this.sorting(this.category, this.sortingOrder, this.sortingKey)
        },
        sorting(type, order, sort) {
            this.skip = 0
            this.order = order
            this.currentPage = 1
            this.sort = sort
            // this.fetchNewRecord(this.skip, this.limit, this.sort, this.order)
            this.loadTableData();
        },
        fetchNewRecord: async function (skip, limit, sort, order) {
            // call api and set data to table
            let params= `?skip=${skip}&limit=${limit}&sort=${sort}&order=${order}`
            let id=this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id 
            console.log('organistaion id', id)
            loader(this,true)
            try{
            const {result} = await getIamUsersForUser(id , params)
            this.usersTableData = result.items.map((user) => {
                return {
                    user: user.userDetails[0],
                    role: user.organisation_role,
                    team_count: user.team_count,
                    user_group_count: user.userGroup_count,
                    permissions: user.permissions,
                    id:user.entity_id
                }
            })
            loader(this,false)
            }
            catch(error){
                loader(this,false)
                message(this, constants.messageType.ERROR, (error))
            }
        },
        async loadTableData(){
            let params= `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
            let id=this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id 
            this.organisation = id
            console.log('this.organisation', this.organisation)
            loader(this,true)
            try{
            let body ={ searchText: this.searchValue}
            const {result} = await getIamUsersForUser(id , params, body)
            this.tableDataCount = result.total_count
            this.usersTableData = result.items.map((user) => {
                return {
                    user: user.userDetails[0],
                    role: user.organisation_role,
                    team_count: user.team_ids.length,
                    user_group_count: user.userGroup_ids.length,
                    permissions: user.permissions,
                    id:user.entity_id
                }
            })
            loader(this,false)
            }
            catch(error){
                message(this, constants.messageType.ERROR, (error))
                loader(this,false)
            }
        },
        setTableFilters(filters) {
            // console.log('setTableFilters', filters)
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        },
        filterCall() {
            this.changePage(1)
        },
        applyFilters() {
            /*  let filtersToApply = {}
             if (!isEmpty(this.selectedTableFilters)) {
                 if (this.selectedTableFilters.city && this.selectedTableFilters.city.length > 0) {
                     filtersToApply.city = this.selectedTableFilters.city
                 }
                 if (this.selectedTableFilters.name && this.selectedTableFilters.name.length > 0) {
                     filtersToApply.name = this.selectedTableFilters.name
                 }
             } 
             this.selectedTableFilters = filtersToApply
             return this.selectedTableFilters */
        },
        async clearSearchInput(){
            this.searchValue=''
            let orgID=this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
            this.skip=0
            this.currentPage=1
        await this.loadTableData(orgID)
        },
    }
}